module.exports = __webpack_public_path__ + "img/bg-h03.a3210403.jpg";